module.exports = __webpack_public_path__ + "static/media/close-cross-red.36b5c005.svg";